import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import { queryClient } from "services/queryClient";

export const useUpateRoleMutation = ({ payload }: { payload: any }) => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (id: string) =>
      axiosInstance
        .patch(`/admins/roles/${id}`, { ...payload, colorCode: "" })
        .then((res: any) => res.data),
    onSuccess: async (data: any) => {
      message.success(data?.message);
      queryClient.invalidateQueries();

      navigate("/admin-management/explore-roles");
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};
